import { Building2, Scale, Calculator, Bot, Zap, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Software de Gestión y Corretaje (CRM)",
    description: "El sistema operativo central para gestionar el ciclo completo de tus propiedades, clientes y cierres.",
    icon: Building2,
    color: "bg-terracotta",
    link: "/servicios/crm"
  },
  {
    title: "Ecosistema Digital IA",
    description: "Automatización de leads con agentes de IA y WhatsApp Business integrado directamente en tu flujo.",
    icon: Bot,
    color: "bg-ink",
    link: "/servicios/ecosistema-digital"
  },
  {
    title: "Valorización IA (HousePricing)",
    description: "Genera informes de tasación precisos con nuestro algoritmo de Machine Learning.",
    icon: Calculator,
    color: "bg-moss",
    link: "/servicios/valorizacion"
  },
  {
    title: "Vende tu Propiedad",
    description: "Módulo de compra directa para liquidar activos de forma rápida y segura al contado.",
    icon: Zap,
    color: "bg-terracotta",
    link: "/servicios/vender-directo"
  },
  {
    title: "Asistencia Legal & Contable",
    description: "Soporte especializado para la revisión de mandatos, escrituras y consultas tributarias.",
    icon: Scale,
    color: "bg-ink",
    link: "/servicios/legal-contable"
  }
];

export function ServicesGrid() {
  return (
    <section className="py-24 bg-parchment border-t-2 border-ink">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-16">
          <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-4 block">Estructura B2B</span>
          <h2 className="text-5xl md:text-7xl font-display font-black uppercase text-ink leading-none mb-8 italic">
            El Ecosistema <br /> Propiedades LATAM
          </h2>
          <p className="text-xl font-serif italic text-ink/60">
            Consolidamos todas las herramientas necesarias para potenciar tu corretaje independiente dentro de una única infraestructura técnica de alto rendimiento.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-1 bg-ink/10">
          {services.map((service, idx) => (
            <Link 
              to={service.link}
              key={idx} 
              className="bg-parchment p-8 hover:bg-white transition-all group cursor-pointer flex flex-col h-full brutalist-border-sm"
            >
              <div className={cn("w-16 h-16 mb-8 flex items-center justify-center text-parchment transition-all group-hover:-rotate-6", service.color, "group-hover:bg-ink")}>
                <service.icon className="h-8 w-8" />
              </div>
              <h3 className="text-xl font-display font-black uppercase mb-4 leading-tight group-hover:text-terracotta transition-colors">
                {service.title}
              </h3>
              <p className="text-sm font-serif italic text-ink/70 mb-8 flex-1">
                {service.description}
              </p>
              <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-terracotta group-hover:text-ink transition-colors">
                VER MÓDULO <ArrowRight className="h-3 w-3" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
